import styled from "styled-components";

export const StyledTabRightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  & .select-year-container {
    width: 100px;
  }
`;

export const StyledMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 24px;
`;
